import "./_import_files";
import "settings";
import requestDemoModal from "modals/requestDemoModal";
import { bindNavEvents } from "util/navigation";
import $ from "jquery";
import "objectFitPolyfill";
import svg4everybody from "svg4everybody";
import Page from "webPage/Page";
import AjaxForm, { EVENT_SUCCESS } from "webPage/AjaxForm";
import Ajax from "base/Ajax";

$(function () {
    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }
    $("body").addClass("has-js").removeClass("no-js");

    $('body').on('click', '.js-accordion-btn', function () {
        if ($(window).outerWidth() < 760) {
            $(this).closest('.accordion').toggleClass('accordion--active');
        }
    }).on('click', '.js-open-demo-modal', function(){
        let href = $(this).attr('href');
        let modal = new requestDemoModal(href);
        modal.show();

        return false;
    });

    bindNavEvents();

    Page.init();
    svg4everybody();

    appHeight();

    let primaryForm = new AjaxForm($('.js-request-demo-primary'), async ($form, formData) => {
        return Ajax.post("contact", "", formData, Ajax.WEBSITE);
    }, {
        validatorSettings: {
            inputs: {
                "agree-terms": {
                    messages: {
                        unchecked: "This field is required",
                    },
                },
            },
        },
    });

    primaryForm.on(EVENT_SUCCESS, () => {
        primaryForm.$element.find('form').hide();
        primaryForm.$element.append([
            eotwJSXFactory('div', {className: "form-success"}, [
                eotwJSXFactory('span', {className: "form-success__icon"}, [
                    eotwJSXFactory('lord-icon', {animation: "auto", src: "/images/lord-icons/183-envelope-mail-approved-outline-edited.json", target: "button"})
                ]),
                eotwJSXFactory('h2', {className: "heading heading--3"}, ["Thank you"]),
                eotwJSXFactory('p', null, ["We’ll be in touch about your demo."]),
                eotwJSXFactory('img', {height: "1", width: "1", style: "display:none;", alt: "", src: "https://px.ads.linkedin.com/collect/?pid=2545905&conversionId=2926001&fmt=gif"})
            ]),
        ]);

        try {
            fbq('track', 'Lead');
        } catch (e) {
            console.log('Could not track lead', e);
        }
    });

    let orangeForm = new AjaxForm($('.js-request-demo-orange'), async ($form, formData) => {
        return Ajax.post("smartRota", "demo-request-orange", formData, Ajax.WEBSITE);
    }, {
        validatorSettings: {
            inputs: {
                "agree-terms-1": {
                    messages: {
                        unchecked: "This field is required",
                    },
                },
            },
        },
    });

    orangeForm.on(EVENT_SUCCESS, () => {
        orangeForm.$element.find('form').hide();
        orangeForm.$element.append([
            eotwJSXFactory('div', {className: "form-success"}, [
                eotwJSXFactory('span', {className: "form-success__icon"}, [
                    eotwJSXFactory('lord-icon', {animation: "auto", src: "/images/lord-icons/183-envelope-mail-approved-outline-edited.json", target: "button"})
                ]),
                eotwJSXFactory('h2', {className: "heading heading--3"}, ["Thank you"]),
                eotwJSXFactory('p', null, ["We’ll be in touch about your demo."]),
                eotwJSXFactory('img', {height: "1", width: "1", style: "display:none;", alt: "", src: "https://px.ads.linkedin.com/collect/?pid=2545905&conversionId=2926001&fmt=gif"})
            ]),
        ]);

        try {
            fbq('track', 'Lead');
        } catch (e) {
            console.log('Could not track lead', e);
        }
    });
});

function appHeight() {
    let doc = document.documentElement;
    doc.style.setProperty('--screen-height', $(window).innerHeight() + 'px');
}
